'use client';

import { Dispatch, SetStateAction, PropsWithChildren } from 'react';
import { Dialog, DialogPanel, DialogBackdrop } from '@headlessui/react';
import { clsx } from 'clsx';

type ModalProps = PropsWithChildren<{
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  panelClassName?: string;
  panelContainerClassName?: string;
}>;

export const Modal = ({
  isOpen,
  setIsOpen,
  children,
  panelClassName,
  panelContainerClassName,
}: ModalProps) => {
  return (
    <Dialog
      open={isOpen}
      onClose={() => setIsOpen(false)}
      className='relative z-50'
    >
      <DialogBackdrop
        transition
        className='bg-black-500 fixed inset-0 duration-200 ease-out opacity-60 data-[closed]:opacity-0'
      />
      <div className={clsx('fixed inset-0', panelContainerClassName)}>
        <DialogPanel
          transition
          className={clsx(
            'data-[closed]:opacity-0 duration-200 ease-out select-none',
            panelClassName
          )}
        >
          {children}
        </DialogPanel>
      </div>
    </Dialog>
  );
};

export default Modal;
